import Breadcrumb from "../../SharedComponents/components/Breadcrumb/Breadcrumb";
import BuyerLayout from "../components/Layout";
import RightArrowIconSVG from "../../SharedComponents/assets/icons/svg/RightArrowIconSVG";
import CreateAddressForm from "../components/AddressesComponents/CreateAddressForm";

const CreateAddressPage = () => {
    const breadcrumbs = [
        { title: "Početak", href: "/home" },
        { title: "Sve adrese", href: "/addresses" },
        { title: "Dodaj adresu" }
    ];

    return (
        <BuyerLayout>
            <div style={styles.topBar}>
                <div style={styles.iconWrapper}>
                    <RightArrowIconSVG />
                </div>
                <Breadcrumb
                    title={"Dodaj adresuuu"}
                    breadcrumbs={breadcrumbs}
                />
            </div>
            <CreateAddressForm />
        </BuyerLayout>
    );
};

export default CreateAddressPage;

const styles = {
    topBar: {
        display: "flex",
    },
    iconWrapper: {
        filter: "brightness(0) saturate(100%)",
        scale: "80%",
        rotate: "180deg",
        paddingTop: "35px",
    },
};
